var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUnlimitBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icUnlimitBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2   0 0 0 0 0.2   0 0 0 0 0.2  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4827586,0 C22.7397285,0 28.9655172,5.02600914 28.9655172,11.691721 C28.9655172,18.3564836 22.7397285,23.3824928 14.4827586,23.3824928 C14.2115166,23.3824928 13.9455788,23.3678992 13.6787972,23.3540175 L13.6611966,23.3531869 L6.63301352,27.9282185 C6.56020009,27.975796 6.47593423,28 6.39166836,28 C6.32054267,28 6.24857311,27.9826775 6.18371612,27.9481512 C6.04146473,27.872929 5.95285899,27.7261625 5.95285899,27.568006 L5.95285899,21.4137817 C2.11086596,19.4475622 0,16.0050171 0,11.691721 C0,5.02600914 6.22578878,0 14.4827586,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Platinum-Diamond",
    transform: "translate(-9.000000, -215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icUnlimitBlack",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(11.000000, 11.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(11.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy-2",
    fill: "#333333",
    transform: "translate(14.482759, 14.000000) scale(-1, 1) translate(-14.482759, -14.000000) ",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "unlimited",
    mask: "url(#mask-4)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 7.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3505556,9.96694444 C18.0892857,9.96694444 20.3174603,7.73876984 20.3174603,5 C20.3174603,2.26123016 18.0892857,0.0330555556 15.3505556,0.0330555556 C14.1834524,0.0330555556 12.7868651,0.716388889 11.0810317,2.12210317 C11.0726984,2.12896825 11.0645635,2.13579365 11.0562698,2.14265873 L13.1146032,4.21043651 C14.6886905,2.95134921 15.3234524,2.93615079 15.3505556,2.93615079 C16.4885317,2.93615079 17.4143651,3.86194444 17.4143651,4.99996032 C17.4143651,6.13797619 16.4885714,7.06376984 15.3505556,7.06376984 C15.3223016,7.06376984 14.6384921,7.04757937 12.9272619,5.63746032 C12.7294048,5.47440476 9.51769841,2.35384921 9.23646825,2.12210317 C7.53063492,0.716388889 6.13404762,0.0330555556 4.96694444,0.0330555556 C2.2281746,0.0330555556 0,2.26123016 0,5 C0,7.73876984 2.2281746,9.96694444 4.96690476,9.96694444 C6.13400794,9.96694444 7.53059524,9.28357143 9.23642857,7.87785714 C9.24416667,7.87146825 9.25174603,7.86511905 9.25944444,7.85873016 L7.20761905,5.78559524 C5.63043651,7.04821429 4.99412698,7.06380952 4.96690476,7.06380952 C3.82892857,7.06380952 2.90309524,6.13801587 2.90309524,5 C2.90309524,3.86198413 3.82888889,2.93619048 4.96690476,2.93619048 C4.99492063,2.93619048 5.75099206,2.86214286 7.36797619,4.34424603 C8.19285714,5.10031746 10.8755556,7.72003968 11.0809921,7.87789683 C12.8338889,9.22452381 14.1834524,9.96694444 15.3505556,9.96694444 Z"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlimitBlack);
export default __webpack_public_path__ + "static/media/icUnlimitBlack.2c530656ff14ecf793974f9d0415a934.svg";
export { ForwardRef as ReactComponent };